import { useTheme } from '../../../../../../../theme/theme';

export const useRetirementIncomeColors = () => {
  const theme = useTheme();

  return {
    incomeShortage: {
      bg: theme.colors.neutral['100'],
      border: theme.colors.neutral['300'],
    },

    distributions: {
      bg: theme.colors.primary['200'],
      border: theme.colors.primary['400'],
    },

    otherIncome: {
      bg: theme.colors.primary['600'],
      border: theme.colors.primary['600'],
    },

    socialSecurity: {
      bg: theme.colors.primary['400'],
      border: theme.colors.primary['400'],
    },

    pension: {
      bg: theme.colors.primary['600'],
      border: theme.colors.primary['600'],
    },

    annuity: {
      bg: theme.colors.primary['700'],
      border: theme.colors.primary['700'],
    },
  };
};
